import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/people-digital-green.svg'


const _hoisted_1 = { class: "result-cannot-continue item-font item-link" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "item-secondary-title pt-2" }, " Your application has been referred to manual underwriting ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "hr mt-4 mb-4" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "item-content" }, " Our underwriter will be in contact shortly. Please continue entering the information of the remaining steps. ", -1)
const _hoisted_6 = { class: "border rounded p-3 mb-5" }
const _hoisted_7 = { class: "item-content" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "mailto: underwriting@booster.co.nz" }, "underwriting@booster.co.nz", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "item-content pt-5 mt-5" }, [
  /*#__PURE__*/_createTextVNode(" If you have any questions, please contact Booster on "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto: insurance@booster.co.nz" }, "insurance@booster.co.nz")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(" To speed up the underwriting process, you can "),
        _createElementVNode("a", {
          href: _ctx.documentPaths.MEDICAL_CONSENT_FORM
        }, "download the Medical Consent Form", 8, _hoisted_8),
        _createTextVNode(" for your client to sign, and send the signed form to "),
        _hoisted_9,
        _createTextVNode(". Alternatively, we will send it to the client if it's required. ")
      ])
    ]),
    _hoisted_10
  ]))
}